var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53817 6L6.70611 10.1973C6.90204 10.3946 7 10.6457 7 10.9507C7 11.2556 6.90204 11.5067 6.70611 11.704C6.51018 11.9013 6.26081 12 5.95801 12C5.65522 12 5.40585 11.9013 5.20992 11.704L0.293893 6.75336C0.187023 6.64574 0.111323 6.52915 0.0667939 6.40359C0.0222646 6.27803 0 6.1435 0 6C0 5.8565 0.0222646 5.72197 0.0667939 5.59641C0.111323 5.47085 0.187023 5.35426 0.293893 5.24664L5.20992 0.295964C5.40585 0.0986547 5.65522 0 5.95801 0C6.26081 0 6.51018 0.0986547 6.70611 0.295964C6.90204 0.493274 7 0.744395 7 1.04933C7 1.35426 6.90204 1.60538 6.70611 1.80269L2.53817 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevButton);
export default __webpack_public_path__ + "static/media/prevButton.1d7129638f0bd6c2519fcb3786b5ed42.svg";
export { ForwardRef as ReactComponent };